import { render, staticRenderFns } from "./ManageMyProject.vue?vue&type=template&id=82c789cc&scoped=true&"
import script from "./ManageMyProject.vue?vue&type=script&lang=js&"
export * from "./ManageMyProject.vue?vue&type=script&lang=js&"
import style0 from "./ManageMyProject.vue?vue&type=style&index=0&id=82c789cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c789cc",
  null
  
)

export default component.exports